export const SET_FORM = "FORM | SET_FORM";
export const RESET_FORM = "FORM | RESET_FORM";

export function setForm(data) {
  return { type: SET_FORM, payload: data };
}

export function resetForm() {
  return { type: RESET_FORM };
}



// WEBPACK FOOTER //
// ./src/store/actions/form.js